// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "article[data-v-0fba42a8]{grid-template-columns:auto auto 1fr auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
